import { useCallback } from 'react';
export const useOnFocus = ({ setFocused }) => {
    const onFocus = useCallback(() => {
        setFocused(true);
    }, [setFocused]);
    return onFocus;
};
